<template>
  <div>
    <div
      class="justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
    >
      <div class="row">
        <h1
          class="h2 text-muted"
          style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; padding-right:5%"
        >
          RATING ENGINE / INSURERS / {{ head_insurer_name }}
        </h1>
      </div>
      <div class="row" style="justify-content: flex-end;">
        <div class="col-2">
          <button
            type="button"
            class="btn btn-danger"
            id="disbut"
            data-bs-toggle="modal"
            data-bs-target="#removeModal"
          >
            Remove
          </button>
        </div>
        <div class="col-2">
          <button
            type="button"
            class="btn btn-primary"
            id="savebut"
            @click="$router.push('/insurers')"
          >
            Save Changes
          </button>
        </div>
      </div>
    </div>
    <div v-if="error" class="alert alert-danger" role="alert">
      This insurer is already present!
    </div>
    <form class="row g-3">
      <div class="col-md-7">
        <label for="fullname" class="form-label">Insurer Name</label>
        <input
          class="form-control"
          id="fullname"
          v-model="insurer_name"
          disabled
          style="color:grey"
        />
      </div>
    </form>
    <!-- Modal -->
    <div
      class="modal fade"
      id="removeModal"
      tabindex="-1"
      aria-labelledby="removeModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Remove Insurer
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="confirmDelete = ''"
            ></button>
          </div>
          <div class="modal-body">
            <div
              class="alert alert-danger d-flex align-items-center"
              role="alert"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="currentColor"
                class="bi bi-exclamation-triangle-fill flex-shrink-0 me-2"
                viewBox="0 0 16 16"
                role="img"
                aria-label="Warning:"
              >
                <path
                  d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
                />
              </svg>
              <div>
                Warning: This action cannot be un-done!
              </div>
            </div>
            <div class="row mb-3">
              <label for="confirmDelete" class="col-sm-8 col-form-label"
                >Are you sure you want to remove this insurer? (Type yes to
                confirm)</label
              >
              <div class="col-sm-4">
                <input
                  class="form-control"
                  id="confirmDelete"
                  v-model="confirmDelete"
                  autocomplete="off"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
              @click="confirmDelete = ''"
            >
              Close
            </button>
            <button
              type="button"
              class="btn btn-primary"
              data-bs-dismiss="modal"
              @click="discard"
            >
              Done
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div
      class="modal fade"
      id="forceRemoveModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="forceRemoveModalLabel">
              Force Remove Insurer
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="confirmDelete = ''"
            ></button>
          </div>
          <div class="modal-body">
            This insurer is associated with calculators and/or mappings. Are you
            sure you still want to remove?
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
              @click="confirmDelete = ''"
            >
              No
            </button>
            <button
              type="button"
              class="btn btn-primary"
              data-bs-dismiss="modal"
              @click="forceRemove"
            >
              Yes
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from "../../config";
import $ from "jquery";
export default {
  data() {
    return {
      insurer_name: "",
      head_insurer_name: "",
      error: false,
      confirmDelete: "",
    };
  },
  methods: {
    async getDeets() {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          data: {
            insurer_id: this.$route.params.id,
          },
        }),
      };
      const response = await fetch(
        config.baseURL + "/get_single_insurer",
        requestOptions
      );
      const data = await response.json();
      if (data == null) this.$router.push("/error");
      console.log(data);
      this.insurer_name = data["insurer_name"];
      this.head_insurer_name = data["insurer_name"];
    },
    async save() {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          data: {
            insurer_id: parseInt(this.$route.params.id),
            insurer_name: this.insurer_name,
          },
        }),
      };
      const response = await fetch(
        config.baseURL + "/update_insurer",
        requestOptions
      );
      const data = await response.json();
      console.log(data);
      if (data["Added"]) this.$router.push("/insurers");
      else this.error = true;
    },
    async discard() {
      if (this.confirmDelete.toLowerCase() === "yes") {
        const requestOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            data: {
              insurer_id: parseInt(this.$route.params.id),
            },
          }),
        };
        const response = await fetch(
          config.baseURL + "/remove_insurer",
          requestOptions
        );
        const data = await response.json();
        console.log(data);
        if (data["Completed"]) this.$router.push("/insurers");
        else $("#forceRemoveModal").modal("show");
      } else {
        this.confirmDelete = "";
      }
    },
    async forceRemove() {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          data: {
            insurer_id: parseInt(this.$route.params.id),
          },
        }),
      };
      const response = await fetch(
        config.baseURL + "/force_remove_insurer",
        requestOptions
      );
      const data = await response.json();
      console.log(data);
      if (data["Completed"]) this.$router.push("/insurers");
    },
  },
  mounted() {
    this.getDeets();
  },
};
</script>

<style scoped></style>
